import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro",
  "use": "micro-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"micro\"><g stroke=\"#000\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"12\" y=\"6\" width=\"8\" height=\"14\" rx=\"4\" /><path d=\"M22 14v1.778C22 19.214 19.314 22 16 22s-6-2.786-6-6.222V14M16 22v4M13 25.5h6M12 16h3M12 13.5h3M12 11h3M17 16h3M17 13.5h3M17 11h3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol